import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { tailwindConfig } from '@/style/config';
import { PROFFIT_BG_PAGE_BUILDING_HEAD, PROFFIT_BG_PAGE_HEAD, } from '@/utils/constants/assets/s3';
const { screens } = tailwindConfig.theme;
export const PageHead = (props) => {
    const { bgImageType, className = '', englishText, text } = props;
    /** 背景画像 */
    const bgImageStyle = {
        building: css `
      background-image: url(${PROFFIT_BG_PAGE_BUILDING_HEAD.sp.webp});

      @media screen and (min-width: ${screens.md}) {
        background-image: url(${PROFFIT_BG_PAGE_BUILDING_HEAD.pc.webp});
      }
    `,
        consultation: css `
      background-image: url(${PROFFIT_BG_PAGE_HEAD.sp.webp});

      @media screen and (min-width: ${screens.md}) {
        background-image: url(${PROFFIT_BG_PAGE_HEAD.pc.webp});
      }
    `,
    };
    return (_jsx("div", Object.assign({ className: clsx('w-full h-[178px] lg:h-[260px]', 'bg-center bg-no-repeat bg-cover', 'flex items-center justify-center', className), css: bgImageStyle[bgImageType] }, { children: _jsxs("div", Object.assign({ className: clsx('flex flex-col items-center lg:gap-y-4') }, { children: [_jsx(Head, Object.assign({ className: 'lg:text-head-xxl', color: 'white', isNormal: true, size: 'md' }, { children: text })), _jsx(Head, Object.assign({ color: 'white', fontFamily: 'alpha', isNormal: true, size: 'xs' }, { children: englishText }))] })) })));
};
